"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const typography_1 = __importDefault(require("../typography/typography"));
const user_avatar_1 = __importDefault(require("./user-avatar"));
require("../../styles/components/user-name-with-avatar-cell.less");
const UserNameWithAvatarCell = ({ value }) => (react_1.default.createElement("div", { className: "user-name-with-avatar-cell" }, typeof value === 'string' ? value : (react_1.default.createElement(react_1.default.Fragment, null,
    react_1.default.createElement(user_avatar_1.default, { ...value }),
    react_1.default.createElement(typography_1.default, { variant: "body1" }, value?.fullName)))));
exports.default = UserNameWithAvatarCell;
//# sourceMappingURL=user-name-with-avatar-cell.js.map